/*
 * Helper functions
 */
const helperFuncs = {
	/**
	 * Loads .svg files from img-elements with class 'js-convert-svg'
	 * and inserts them into DOM as <svg>-elements replacing the <img>-tag.
	 */
	convertSVG(): void {
	  // If SVG isn't supported, abort.
	  if (typeof SVGRect === 'undefined') return;
  
	  const convertElems = document.querySelectorAll<HTMLImageElement>('img.js-convert-svg[src$=".svg"]');
  
	  convertElems.forEach((el: HTMLImageElement) => {
		const imgUrl = el.src;
		const attributes = el.attributes;
  
		const ajax = new XMLHttpRequest();
		ajax.open('GET', imgUrl, true);
		ajax.send();
  
		ajax.onload = () => {
		  const svgString = ajax.responseText;
		  const svgEl = helperFuncs.stringToHTML(svgString);
		  const attributeEntries = Array.from(attributes);
  
		  // Add attributes from the img-element to the new svg-element
		  attributeEntries.forEach(attrObj => {
			if (!attrObj || attrObj.name === 'src') return;
			svgEl.setAttribute(attrObj.name, attrObj.value);
		  });
  
		  el.replaceWith(svgEl);
		};
	  });
	},
  
	/**
	 * Converts an HTML string to a single HTMLElement.
	 */
	stringToHTML(htmlString: string): SVGElement {
	  const parser = new DOMParser();
	  const doc = parser.parseFromString(htmlString, 'image/svg+xml');
	  return doc.documentElement as unknown as SVGElement;
	}
  };
  
  export { helperFuncs };